import type { ReactNode } from 'react';
import { faXmark } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import { Heading5 } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

interface SettingsPopoverPanelProps {
  title: string;
  children: ReactNode;
  onRequestClose?: () => void;
  className?: string;
}

export function SettingsPopoverPanel({
  title,
  children,
  onRequestClose,
  className,
}: SettingsPopoverPanelProps) {
  return (
    <div className={cn('relative flex max-h-[min(82vh,760px)] flex-col p-4 space-y-2', className)}>
      <Heading5>{title}</Heading5>

      {onRequestClose ? (
        <Button
          variant="ghost"
          colorScheme="secondary"
          size="icon-sm"
          className="absolute top-4 right-4"
          onClick={onRequestClose}
        >
          <Icon icon={faXmark} />
          <span className="sr-only">Close settings</span>
        </Button>
      ) : null}

      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
}
